const burgerToggle = document.querySelector('.js-burger-toggle');
const expandButtons = document.querySelectorAll('.js-block-header-mobile__expand');

if (burgerToggle) {
  burgerToggle.addEventListener('click', function (event) {
    const burgerToggle = event.target;

    burgerToggle.setAttribute('aria-expanded', burgerToggle.getAttribute('aria-expanded') === 'false');
  });
}

if (expandButtons) {
  [].forEach.call(expandButtons,function (expandButton) {
    expandButton.addEventListener('click', toggleMobileSubmenu);
    expandButton.addEventListener('keydown', (event) => {
      if (event.keyCode === 32) { // Space
        toggleMobileSubmenu(event);
      }
    });
  });
}

function toggleMobileSubmenu(event) {
  event.preventDefault();

  const expandButton = event.target;

  expandButton.setAttribute('aria-expanded', expandButton.getAttribute('aria-expanded') === 'false');
}